import React from 'react';
import LossesVendorSection from '../../../../components/Layout-Components/Editor-Layout/Losses-Toggle/LossesVendorSection';

const LossesProperties: React.FC = () => {
    return (
        <div className='tab__inner'>
            <div className='tab__title'>
                <span className='tab__title--text tab__title--flex'>Losses</span>
            </div>
            <LossesVendorSection/>
        </div>
    );
}

export default LossesProperties;
